import BlogPosts from "pages/MyBlogs/blogPosts/blogposts";



export default (BlogPosts);